import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';

import Select from '@atlaskit/select';

const initialCache = {
  options: [],
  hasMore: true,
  isLoading: false,
};

class SelectAsyncPaginate extends Component {
  static propTypes = {
    isMulti: PropTypes.bool.isRequired,
    loadOptions: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    cacheUniq: PropTypes.any,
    // eslint-disable-next-line react/forbid-prop-types
    selectRef: PropTypes.object,
    options: PropTypes.arrayOf(PropTypes.object),
    selectedOptions: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    cacheUniq: null,
    selectRef: {
      current: null,
    },
    options: null,
    selectedOptions: null,
  };

  inputTimeout = null;

  constructor(props) {
    super(props);

    const initialOptionsCache = props.options
      ? {
        '': {
          isLoading: false,
          options: props.options,
          hasMore: true,
        },
      }
      : {};

    this.state = {
      search: '',
      optionsCache: initialOptionsCache,
      inputTyping: false,
      menuIsOpen: false,
    };
  }

  componentDidUpdate(oldProps) {
    const { cacheUniq } = this.props;

    if (oldProps.cacheUniq !== cacheUniq) {
      this.setState({ /* eslint-disable-line */
        optionsCache: {},
      });
    }
  }

  onMenuClose = () => {
    this.setState({
      search: '',
      menuIsOpen: false,
    });
  }

  onMenuOpen = async () => {
    this.setState({
      menuIsOpen: true,
    });

    const { optionsCache } = this.state;

    if (!optionsCache['']) {
      await this.loadOptions('');
    }
  }

  onInputChange = async (search, { action }) => {
    if (action === 'input-change') {
      this.setState({
        search,
      });
    }
    if (action !== 'set-value') {
      this.setState({
        inputTyping: true,
      });

      if (this.inputTimeout) {
        clearTimeout(this.inputTimeout);
      }
      this.inputTimeout = setTimeout(() => {
        this.setState({
          inputTyping: false,
        });
        const { optionsCache } = this.state;

        if (!optionsCache[search]) {
          this.loadOptions(search);
        }
      }, 500);
    }
  }

  onMenuScrollToBottom = async () => {
    const {
      search,
      optionsCache,
    } = this.state;
    const currentOptions = optionsCache[search];

    if (currentOptions) {
      await this.loadOptions(search);
    }
  }

  async loadOptions(search) {
    const { optionsCache } = this.state;
    const currentOptions = optionsCache[search] || initialCache;

    if (currentOptions.isLoading || !currentOptions.hasMore) {
      return;
    }

    this.setState(prevState => ({
      optionsCache: {
        ...prevState.optionsCache,
        [search]: {
          ...currentOptions,
          isLoading: true,
        },
      },
    }));

    try {
      const { loadOptions } = this.props;

      const {
        options,
        hasMore,
      } = await loadOptions(search, currentOptions.options);

      this.setState(prevState => ({
        optionsCache: {
          ...prevState.optionsCache,
          [search]: {
            ...currentOptions,
            options: currentOptions.options.concat(options),
            hasMore: !!hasMore,
            isLoading: false,
          },
        },
      }));
    } catch (e) {
      this.setState(prevState => ({
        optionsCache: {
          ...prevState.optionsCache,
          [search]: {
            ...currentOptions,
            isLoading: false,
          },
        },
      }));
    }
  }

  render() {
    const {
      selectRef,
      selectedOptions,
    } = this.props;

    const {
      search,
      inputTyping,
      optionsCache,
      menuIsOpen,
    } = this.state;

    const currentOptions = optionsCache[search] || initialCache;
    const options = this.props.isMulti ? (
      currentOptions.options.map(
        o => ({
          ...o,
          ...(
            o.value
              ? ({
                isSelected: (
                  selectedOptions
                    .findIndex(
                      so => (
                        so.option.value === o.value
                      ),
                    ) !== -1
                ),
              })
              : {}
          ),
          ...(
            o.options
              ? ({
                options: (
                  o.options.map(
                    option => ({
                      ...option,
                      isSelected: (
                        selectedOptions
                          .findIndex(
                            so => (
                              so.option.value === option.value
                            ),
                          ) !== -1
                      ),
                    }),
                  )
                ),
              })
              : {}
          ),
        }),
      )
    ) : (
        currentOptions.options.map((option) => {
          if (this.props.value === option.value) {
            return ({
              ...option,
              isSelected: true,
            });
          }
          return option;
        })
    );

    return (
      <Select
        {...this.props}
        inputValue={search}
        menuIsOpen={menuIsOpen}
        onMenuClose={this.onMenuClose}
        onMenuOpen={this.onMenuOpen}
        onInputChange={this.onInputChange}
        onMenuScrollToBottom={this.onMenuScrollToBottom}
        isLoading={inputTyping || currentOptions.isLoading}
        options={options}
        ref={selectRef}
      />
    );
  }
}

export default SelectAsyncPaginate;
